import { Typography } from '@mui/material';
import { InteractiveModal } from 'components/Modals/InteractiveModal/BaseModal';
import UserHandler from 'handlers/internal.user.handler';
import { useTranslation } from 'react-i18next';

export {};

/**
 *
 * The deactivation modal is a modal that is used to deactivate a user.
 */

interface Props {
  open: boolean;
  userId: string;
  firstName: string;
  lastName: string;
  handleAbort: () => void;
}

export const UserDeactivationModal = ({
  open,
  userId,
  firstName,
  lastName,
  handleAbort,
}: Props) => {
  const { t } = useTranslation();
  const userHandler = new UserHandler();
  const title = `Confirm Deletion of ${firstName} ${lastName}`;
  return (
    <InteractiveModal
      initialState={open}
      title={title}
      handleAbort={handleAbort}
      SuccessButtonProps={{
        onClick: async () => {
          await userHandler.deactivateInternalUser(userId, firstName, lastName);
          handleAbort();
        },
        disabled: false,
        label: t('delete_user'),
      }}
      ModalContentProps={{
        gridItemProps: {
          lg: 12,
        },
      }}
    >
      <Typography key="blurb-1" variant="medium">
        {t('upon_user_deletion_this_user_will_no_longer_have_access_to_t')}
      </Typography>
      <Typography key="blurb-2" variant="medium">
        {t('to_resurrect_a_user_create_a_ticket_with_the_dev_team')}
      </Typography>
    </InteractiveModal>
  );
};
